<template>
    <Box title="资产详情">
        <div>
            <van-tabs @click="propconfirm" type="line" background="#4FA69E" color="#ffffff" v-model="activeIndex"
                sticky swipeable>
                <van-tab v-for="(item,key) in arrauList" :key="key" :title="item.name" :name="item.id">
                </van-tab>
            </van-tabs>
        </div>
        <!-- <ImgModule upload :disabled='true' :deletable="false" v-if="Imgdata" title="资产图片" :img="Imgdata"/> -->
        <div class="infoBox" v-if="activeIndex===0">
            <p class="title">资产信息</p>
            <div>
                <span>资产名称：</span>
                <span>{{data.EquName}}</span>
            </div>
            <div>
                <span>资产编号：</span>
                <span>{{data.EquCode}}</span>
            </div>
            <!--这是新加的-->
            <div>
                <span>原资产编号：</span>
                <span>{{data.YSBBH}}</span>
            </div>
            <div>
                <span>条码号：</span>
                <span>{{data.TMH}}</span>
            </div>
            <div>
                <span>有效期：</span>
                <span>{{data.YXQ||0}}年</span>
            </div>
            <div>
                <span>报检日期：</span>
                <span>{{data.BJRQ}}</span>
            </div>

            <div>
                <span>规格型号：</span>
                <span>{{data.EquType}}</span>
            </div>
            <div>
                <span>资产单位：</span>
                <span>{{data.EquUnit}}</span>
            </div>
            <div>
                <span>序列号：</span>
                <span>{{data.EquNumber}}</span>
            </div>
            <div>
                <span>注册证件号：</span>
                <span>{{data.Number}}</span>
            </div>
            <div>
                <span>使用科室：</span>
                <span>{{data.DepartmentName}}</span>
            </div>
            <div>
                <span>存放地址：</span>
                <span>{{data.CFDDMC==null?data.CFDD:data.CFDDCMC}}</span>
            </div>
            <div>
                <span>财产分类：</span>
                <span>{{data.FinanceClass}}</span>
            </div>
            <div>
                <span>财务编号：</span>
                <span>{{data.CWBH}}</span>
            </div>
            <div>
                <span>是否效益分析：</span>
                <span>{{data.IsAnalysis}}</span>
            </div>
            <div>
                <span>是否计量设备：</span>
                <span>{{data.IsMetering}}</span>
            </div>
            <div>
                <span>启用日期：</span>
                <span>{{data.StartDate}}</span>
            </div>
            <div>
                <span>原值：</span>
                <span>{{data.ContractPrice}}</span>
            </div>
            <div>
                <span>折旧：</span>
                <span>{{data.Depreciation}}</span>
            </div>
            <div>
                <span>净值：</span>
                <span>{{data.NetValue}}</span>
            </div>
            <div>
                <span>使用年限（月）：</span>
                <span>{{data.EstimateDate}}</span>
            </div>
            <div>
                <span>品牌：</span>
                <span>{{data.BrandName}}</span>
            </div>
            <div>
                <span>国别：</span>
                <span>{{data.CountriesName}}</span>
            </div>
            <div>
                <span>产地：</span>
                <span>{{data.OriginName}}</span>
            </div>
            <div>
                <span>生产厂家：</span>
                <span>{{data.FactoryName}}</span>
            </div>
            <div>
                <span>供应商：</span>
                <span>{{data.SupplierName}}</span>
            </div>
            <div>
                <span>状态：</span>
                <span>{{data.Status}}</span>
            </div>
        </div>
        <div v-else-if="activeIndex===1" class="itemsTop">
            <van-cell-group v-for="(item,index) in licenseList" :key='index' @click.stop="GetAccessoryBefor(item)">
                <van-cell title="证件编号" :value="item.ZJBH"/>
                <van-cell title="厂家名称" :value="item.ZJSSQYMC" />
                <van-cell title="厂家类别" :value="item.PJMC" />
                <van-cell title="证件名称" :value="item.ZJMC" />
                <van-cell title="有效期类型" :value="item.ZJYXQLX==='0'?'短期':'长期'" />
                <van-cell>
                    <template>
                        <div class="TimeClass">
                            <div>
                                <span>开始日期：</span>
                                <p>{{$format(item.KSRQ?item.KSRQ:'','YYYY-MM-DD')}}</p>
                            </div>
                            <div>
                                <span>截止日期：</span>
                                <p>{{$format(item.JZRQ?item.JZRQ:'','YYYY-MM-DD')}}</p>
                            </div>
                        </div>
                    </template>
                </van-cell>
            </van-cell-group>
            <van-popup v-model="show" position="top" :style="{width:'100%',height:'100%'}">
                <div class="accessory">
                    <van-sticky>
                        <div class="accessoryTotal">
                            <span>共:{{Total}}条</span>
                            <i @click="show=false" class="van-icon van-icon-close van-popup__close-icon van-popup__close-icon--top-right" />
                        </div>
                    </van-sticky>
                    <van-cell-group v-for="(item,index) in accessoryList" :key='index'>
                        <van-cell title="附件名称" :value="item.FJMZ" />
                        <van-cell title="附件类型" :value="(item.BCLJ.split('.'))[item.BCLJ.split('.').length-1]" />
                        <van-cell>
                            <template>
                                <div class="accessoryButton">
                                    <div @click="ImagClick(item)" v-if="ImgTypeArray.findIndex(x=>x===(item.BCLJ.split('.'))[item.BCLJ.split('.').length-1])!==-1">查看</div>
                                    <div @click="SaveAccessory(item.BCLJ)">下载</div>
                                </div>
                            </template>
                        </van-cell>
                    </van-cell-group>
                    <div class="pageClass" v-if="accessoryList.length!==0">
                        <van-pagination v-model="Page" :page-count="Math.ceil(Total/10)" mode="simple" @change="GetAccessory" />
                    </div>
                </div>
            </van-popup>
        </div>
        <div v-else-if="activeIndex===2" class="itemsTop">
            <van-cell-group v-for="(item,index) in InstallationAcceptanceList" :key='index'>
                <van-cell title="档案名称" :value='item.DAMC' />
                <van-cell title='档案类型' :value="(item.DALJ.split('.'))[item.DALJ.split('.').length-1]" />
                <van-cell>
                    <template>
                        <div class="InstallationAcceptanceButton">
                            <div @click="ImagClick(item)" v-if="ImgTypeArray.findIndex(x=>x===(item.DALJ.split('.'))[item.DALJ.split('.').length-1])!==-1">查看</div>
                            <div @click="SaveAccessory(item.DALJ)">下载</div>
                        </div>
                    </template>
                </van-cell>
            </van-cell-group>
            <div class="pageClass" v-if="InstallationAcceptanceList.length!==0">
                <van-pagination v-model="InstallationAcceptancePage" :page-count="Math.ceil(InstallationAcceptanceTotal/10)"
                    mode="simple" @change="GetInstallationAcceptanceList" />
            </div>
        </div>
        <div v-if="activeIndex===3" class="itemsTop">
            <van-cell-group v-for="(item,index) in MaintainList" :key="index" @click.stop="redirect(item)">
                <van-cell title="维修单号" :value='item.BH' />
                <van-cell title="报修人" :value="item.BXRXM" />
                <van-cell title="报修科室" :value="item.KSMC" />
                <van-cell title="报修科室" :value="item.KSMC" />
                <van-cell title="报修时间" :value="item.SXSJ" />
                <van-cell title="维修人" :value="item.WXRXM" />
                <van-cell title="维修时间" :value="item.WXRQ" />
                <van-cell title="维修原因" :value="item.WXYY" />
                <van-cell title="是否修复" :value="item.SFXF" />
                <van-cell>
                    <template>
                        <div class="MaintainButtonClass">详情</div>
                    </template>
                </van-cell>
            </van-cell-group>
            <div class="pageClass" v-if="MaintainList.length!==0">
                <van-pagination v-model="MaintainPage" :page-count="Math.ceil(MaintainTotal/10)" mode="simple" @change="GetMaintainList" />
            </div>
        </div>
        <!--保养-->
        <div v-else-if="activeIndex===4" class="itemsTop">
            <van-cell-group v-for="(item,index) in UpkeepList" :key="index" @click.stop="$router.push({name:'MaintainImplementDefault',params:{item,ButtonExists:true}})">
                <van-cell title="计划单号" :value="item.JHDH" />
                <van-cell title="实施单号" :value="item.SSDH" />
                <van-cell title="保养周期" :value="item.JCZQ" />
                <van-cell title="计划类型" :value="item.JHLX" />
                <van-cell title="执行科室" :value="item.ZXKSMC" />
                <van-cell title="执行科室" :value="item.ZXKSMC" />
                <van-cell title="执行人" :value="item.JCJG" />
                <van-cell title="保养时间" :value="item.BCJCRQ" />
                <van-cell>
                    <template>
                        <div class="MaintainButtonClass">详情</div>
                    </template>
                </van-cell>
            </van-cell-group>
            <div class="pageClass" v-if="UpkeepList.length!==0">
                <van-pagination v-model="UpkeepPage" :page-count="Math.ceil(UpkeepTotal/10)" mode="simple" @change="GetUpkeepList" />
            </div>
        </div>
        <div v-if="activeIndex===5" class="itemsTop">
            <van-cell-group v-for="(item,index) in QualificationList" :key='index'>
                <van-cell title="档案名称" :value='item.DAMC' />
                <van-cell title='档案类型' :value="(item.DALJ.split('.'))[item.DALJ.split('.').length-1]" />
                <van-cell>
                    <template>
                        <div class="InstallationAcceptanceButton">
                            <div @click="ImagClick(item)" v-if="ImgTypeArray.findIndex(x=>x===(item.DALJ.split('.'))[item.DALJ.split('.').length-1])!==-1">查看</div>
                            <div @click="SaveAccessory(item.DALJ)">下载</div>
                        </div>
                    </template>
                </van-cell>
            </van-cell-group>
            <div class="pageClass" v-if="QualificationList.length!==0">
                <van-pagination v-model="QualificationPage" :page-count="Math.ceil(QualificationTotal/10)"
                    mode="simple" @change="GetQualificationList" />
            </div>
        </div>
        <div v-if="activeIndex===6" class="itemsTop">
            <van-cell-group v-for="(item,index) in InvoiceList" :key='index'>
                <van-cell title="档案名称" :value='item.DAMC' />
                <van-cell title='档案类型' :value="(item.DALJ.split('.'))[item.DALJ.split('.').length-1]" />
                <van-cell>
                    <template>
                        <div class="InstallationAcceptanceButton">
                            <div @click="ImagClick(item)" v-if="ImgTypeArray.findIndex(x=>x===(item.DALJ.split('.'))[item.DALJ.split('.').length-1])!==-1">查看</div>
                            <div @click="SaveAccessory(item.DALJ)">下载</div>
                        </div>
                    </template>
                </van-cell>
            </van-cell-group>
            <div class="pageClass" v-if="InvoiceList.length!==0">
                <van-pagination v-model="InvoicePage" :page-count="Math.ceil(InvoiceTotal/10)"
                    mode="simple" @change="GetInvoiceList" />
            </div>
        </div>
    </Box>
</template>

<script>
    import {
        Tab,
        Cell,
        Tabs,
        CellGroup,
        Popup,
        ImagePreview,
        sticky,
        Pagination
    } from 'vant'
    import Box from '../../components/commonBox/commonBox'
    import ImgModule from '../../components/imgModule/imgModule'
    import DownLoad from '../../../tool/download.js'
    export default {
        name: 'PropertyDetails',
        components: {
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Popup.name]: Popup,
            [sticky.name]: sticky,
            [ImagePreview.name]: ImagePreview,
            [Pagination.name]: Pagination,
            Box,
            ImgModule
        },
        data() {
            return {
                itemData: {}, //临时item
                Page: 1,
                ImgTypeArray: ['png', 'jpg', 'jpeg', 'bmp', 'gif'], //image 类型
                Total: 0,
                accessoryList: [], //附件list
                show: false, //弹出框是否显示
                finished: false,
                loading: false,
                data: {},
                Imgdata: [],
                arrauList: [{
                        id: 0,
                        name: "基本信息"
                    }, {
                        id: 1,
                        name: "证照"
                    }, {
                        id: 2,
                        name: "安装验收"
                    }, {
                        id: 3,
                        name: "维修"
                    },
                    {
                        id: 4,
                        name: "保养"
                    }, {
                        id: 5,
                        name: "合格证"
                    }, {
                        id: 6,
                        name: "发票"
                    }
                ],
                activeIndex: 0, //选项卡索引
                licenseList: [], //证照List
                InstallationAcceptanceList: [], //安装验收List
                InstallationAcceptancePage: 1, //安装验收页码
                InstallationAcceptanceTotal: 0, //安装验收总数
                MaintainList: [], //维修信息列表
                MaintainPage: 1, //维修页码
                MaintainTotal: 0, //维修总条数
                UpkeepList: [], //保养列表
                UpkeepPage: 1, //保养页码
                UpkeepTotal: 0, //保养总条数
                QualificationList:[],//合格证列表
                QualificationPage:1,//合格证页码
                QualificationTotal:0,//合格证数量
                InvoiceList:[],//发票列表
                InvoicePage:1,//发票页码
                InvoiceTotal:0,//发票总条数

            }
        },
        mounted() {
            this.loadImgDefault(); //获取图片
        },
        methods: {
            loadImgDefault(EquCode) {
                this.$post('api/Repair/GetTPListByDALX', {
                    SBBH: this.data.EquCode,
                    DALX: '12', //只查询资产图片
                    Sotre: this.$UserInfo.StoreCode,
                    isDownload: false
                }).then(result => {
                    for (let i = 0; i < result.TPList.length; i++) {
                        this.Imgdata.push({
                            DABH: result.TPList[i].DABH,
                            url: result.TPList[i].RePath
                        });
                    }
                    this.SetTime();
                })
            },
            loadDataDefault() {
                this.$get('api/Repair/EquipmentDetail', {
                    SBBH: this.$route.params.item.EquCode||this.$route.params.item.SBBH
                }).then(result => {
                    if (result.Equipment.length !== 1) {
                        this.$Toast('数据异常,请联系管理员!');
                        return false
                    }
                    this.data = result.Equipment[0];
                })
            },
            SetTime() {
                // if (this.$route.params.pageState) this.data = this.$route.params.item; //如果前页pageState为true，不用再次请求 false   需要请求api/Repair/PropertyQuery
                // else this.loadDataDefault(); //档案、资产综合查询  不需要进行查询，转科、报废需要从新查询
                this.loadDataDefault();
            },
            propconfirm() { //选项卡点击事件
                if (!this.data) {
                    return;
                }
                if (this.activeIndex === 1 && this.licenseList.length === 0) { //证照
                    this.$get('api/Property/GetLicenseList', {
                        GYS: this.data.SupplierId,
                        SCCJ: this.data.FactoryId,
                        SBMCBH: this.data.DictionId,
                        SBBH: this.data.EquCode
                    }).then(result => {
                        this.licenseList = result;
                    })
                } else if (this.activeIndex === 2 && this.InstallationAcceptanceList.length === 0) { //安装验收
                    this.GetInstallationAcceptanceList();
                } else if (this.activeIndex === 3 && this.MaintainList.length === 0) { //维修记录
                    this.GetMaintainList();
                } else if (this.activeIndex === 4 && this.UpkeepList.length === 0) { //保养记录
                    this.GetUpkeepList();
                } else if(this.activeIndex===5 && this.QualificationList.length===0){//合格证
                    this.GetQualificationList();
                } else if(this.activeIndex===6&&this.InvoiceList.length===0){//发票
                    this.GetInvoiceList()
                }
            },
            ImagClick(item) {
                ImagePreview({
                    images: [
                        item.RePath
                    ],
                    swipeDuration: 10000,
                    closeOnPopstate: true,
                })
            },
            SaveAccessory(item) {
                try {
                    DownLoad('api/' + item);
                } catch (e) {
                    this.$Toast('系统异常，请联系管理员!');
                }
            },
            GetAccessoryBefor(item) {
                this.itemData = item;
                this.GetAccessory();
            },
            GetAccessory() { //点击查询附件详情
                this.$get('api/Property/GetAccessoryInEquCode', {
                    QYBH: this.itemData.ZJSSQY,
                    ZJHH: this.itemData.ZJHH,
                    PageIndex: this.Page,
                    pageSize: 10
                }).then(result => {
                    //this.$scrollscreen('.accessory','start');
                    this.accessoryList = result.Rows;
                    this.Total = result.Total;
                    this.show = true;
                })
            },
            GetInstallationAcceptanceList() { //获取安装验收
                this.$get('api/Property/GetInstallationAcceptanceList', {
                    SBBH: this.data.EquCode,
                    Store: this.$UserInfo.StoreCode,
                    ISYSRK: '0',
                    DALX: '',
                    pageIndex: this.InstallationAcceptancePage,
                    pageSize: 10,
                }).then(result => {
                    this.InstallationAcceptanceList = result.Rows;
                    this.InstallationAcceptanceTotal = result.Total;
                })
            },
            GetMaintainList() { //获取维修记录
                this.$get('api/Property/GetMaintainList', {
                    SBBH: this.data.EquCode,
                    pageIndex: this.MaintainPage,
                    pageSize: 10
                }).then(result => {
                    try {
                        result = JSON.parse(result);
                        this.MaintainList = result.rows;
                        this.MaintainTotal = result.total;
                    } catch (e) {
                        this.$Toast('系统异常,请联系管理员!');
                    }
                })
            },
            redirect(item) { //维修处理数据操作
                let ImageArray = [];
                let ProcessDefault = {
                    RepairMark: '',
                    AccessoriesMoney: 0,
                    MaintainMoney: 0,
                    RepairTypeName: "自修",
                    RepairType: '',
                    WXGS: 0,
                    TotalMoney: 0
                }
                this.$get('api/Repair/MaintenanceOther', {
                    WXDH: item.BH,
                    JCHH: '1'
                }).then(result => {
                    //维修进程的处理
                    if (result.ProcessDefault.length > 0) {
                        let data = result.ProcessDefault[0];
                        ProcessDefault.RepairMark = data.RepairMark;
                        ProcessDefault.AccessoriesMoney = data.AccessoriesMoney ? data.AccessoriesMoney : 0;
                        ProcessDefault.MaintainMoney = data.MaintainMoney ? data.MaintainMoney : 0; //维修费用
                        ProcessDefault.RepairTypeName = data.RepairTypeName;
                        ProcessDefault.RepairType = data.RepairType;
                        ProcessDefault.WXGS = data.WXGS ? data.WXGS : 0;
                        ProcessDefault.TotalMoney = ProcessDefault.AccessoriesMoney + ProcessDefault.MaintainMoney;
                    };

                    //图片处理
                    result.accessory.forEach(function(item, index) {
                        ImageArray.push({
                            HH: item.HH,
                            url: item.Repath,
                            Repath: item.WJLJ
                        });
                    })
                    item = {
                        RepairOrder: item.BH,
                        EquCode: item.SBBH,
                    };
                    this.skip(item, ProcessDefault, ImageArray).then(res => {
                        this.$Bus.$emit('selectAccessories', result.accessories); //配件
                        this.$Bus.$emit('selectStaff', result.serviceman); //人员
                        this.$Bus.$emit('YSRKDelete', ImageArray); //图片
                    })
                })
            },
            skip(item, ProcessDefault, ImageArray) { //维修处理跳转页面
                return new Promise((resolve, reject) => {
                    this.$router.push({
                        name: 'Pending',
                        params: {
                            item,
                            ProcessDefault,
                            ImageArray,
                            ButtonExists: true
                        }
                    });
                    resolve();
                })
            },
            GetUpkeepList() { //获取保养
                this.$get('api/Property/GetUpkeepList', {
                    SBBH: this.data.EquCode,
                    STORE: this.$UserInfo.StoreCode,
                    pageIndex: this.UpkeepPage,
                    pageSize: 10,
                }).then(result => {
                    try {
                        result = JSON.parse(result);
                        this.UpkeepList = result.rows;
                        this.UpkeepTotal = result.total;
                    } catch (e) {
                        this.$Toast('系统异常,请联系管理员!');
                    }
                })
            },GetQualificationList(){//合格证
                this.$get('api/Property/GetInstallationAcceptanceList', {
                    SBBH: this.data.EquCode,
                    Store: this.$UserInfo.StoreCode,
                    ISYSRK: '10',
                    DALX: '',
                    pageIndex: this.QualificationPage,
                    pageSize: 10,
                }).then(result => {
                    this.QualificationList = result.Rows;
                    this.QualificationTotal = result.Total;
                })
            },GetInvoiceList(){//发票
                this.$get('api/Property/GetInstallationAcceptanceList',{
                    SBBH: this.data.EquCode,
                    Store: this.$UserInfo.StoreCode,
                    ISYSRK: '11',
                    DALX: '',
                    pageIndex: this.InvoicePage,
                    pageSize: 10,
                }).then(result => {
                    this.InvoiceList = result.Rows;
                    this.InvoiceTotal = result.Total;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .imgModuleBox {
        margin-top: 25px;
    }

    .infoBox {
        div {
            display: flex;
            align-items: center;
            font-size: 29px;
            margin-bottom: 26px;

            span:first-child {
                flex: 1;
                color: #999;
            }

            span:last-child {
                color: $TEXT-DARK-COLOR;
            }
        }
    }

    .itemsTop {
        .van-cell-group {
            margin-top: 10px;
        }
        margin-top: 100px;

        .TimeClass {
            &>div {
                p {
                    display: inline-block;
                    width: 50%;
                    float: right;
                }

                &:first-child {
                    float: left;
                    display: inline-block;
                    width: 50%;

                    span {
                        width: 40%;
                    }

                }

                &:last-child {
                    float: right;
                    display: inline-block;
                    width: 50%;

                    span {
                        width: 40%;
                    }

                }
            }
        }

        .accessory {
            .accessoryTotal {
                height: 100px;
                background: #4FA69E;
                color: #fff;

                span {
                    position: relative;
                    top: 30px;
                    left: 30px;
                }
            }

            .accessoryButton {

                width: 60%;
                float: right;

                div {
                    border-radius: 1em;
                    float: right;
                    width: 30%;
                    display: inline-block;
                    background: #4FA69E;
                    margin: 0 10px;
                    text-align: center;
                    color: #fff;
                }

                &>div {
                    &:last-child {
                        background: #FF9E48;
                    }
                }
            }
        }

        .pageClass {
            margin-top: 50px;
        }

        .InstallationAcceptanceButton {
            div {
                float: right;
                display: inline-block;
                width: 20%;
                text-align: center;
                margin: 0 10px;
                border-radius: 1em;
                color:#FFFFFF;
            }

            &>div {

                &:first-child {
                    background: #4FA69E;
                }

                &:last-child {
                    background: #FF9E48;
                }
            }
        }

        .MaintainButtonClass {
            float: right;
            background: #FF9E48;
            border-radius: 1em;
            color: #fff;
            width: 15%;
            text-align: center;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/propertyDetails/propertyDetails.vue